import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'spinner-specs',
  templateUrl: './spinner-specs.component.html',
  styleUrls: ['./spinner-specs.component.sass']
})
export class SpinnerSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/spinner/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
